import React, { useEffect, useState } from 'react';
import { Row, Col, Modal } from 'antd';
import { Route, RouteComponentProps, Link } from 'react-router-dom';

import styled from 'styled-components';

const TrackVideo = () => {
  return (
    <>
      <Row gutter={[32, 16]}>
        {data.length > 0 &&
          data.map((item, index) => (
            <ColStyled span={6}>
              <Link to={`/track-video/${index}`}>
                {/* <img src={item.img} alt="1"></img> */}
                <video
                id="myVideo"
                style={{
                  width: '100%',
                  height: '100%',
                }}
                width="100%"
                autoPlay={false}
                controls={false}
                controlsList="nodownload"
                preload="auto"
                data-object-fit="contain"
              >
                {<source src={item?.video}></source>}
              </video>
                <p>{item.title}</p>
              </Link>
            </ColStyled>
          ))}
      </Row>
      <Route
        path="/track-video/:id"
        component={(props: RouteComponentProps<{ id: string }>) => {
          const id = props.match.params.id;

          return (
            <ModalStyled
              key="add"
              visible={true}
              onCancel={e => {
                props.history.goBack();
              }}
              footer={null}
            >
              <video
                id="myVideo"
                style={{
                  width: '100%',
                  height: '100%',
                }}
                width="100%"
                autoPlay={true}
                controls
                controlsList="nodownload"
                preload="auto"
                data-object-fit="contain"
              >
                {<source src={data[id]?.video}></source>}
              </video>
            </ModalStyled>
          );
        }}
      />
    </>
  );
};

export default TrackVideo;

const ColStyled = styled(Col)`
  margin-top: 16px;
  overflow: hidden;
  text-align: center;
  cursor: pointer;
  img {
    width: 100%;
    height: 155px;
  }
`;

const ModalStyled = styled(Modal)`
  width: 700px !important;
  .ant-modal-body {
    padding: 0;
  }
`;

const data = [
  {
    img:
      'https://sino-study.oss-cn-hongkong.aliyuncs.com/pro/images/1565593020683/%E6%B5%B7%E6%8A%A5%E5%8D%95%E5%9B%BE%20-%200327.jpg',
    video:
      'https://sinoclick-test.oss-cn-hongkong.aliyuncs.com/shopify-pixel/demo/demo-1.mp4',
    title: 'Facebook Pixel',
  },
  {
    img:
      'https://sino-study.oss-cn-hongkong.aliyuncs.com/pro/images/1565593020683/%E6%B5%B7%E6%8A%A5%E5%8D%95%E5%9B%BE%20-%200327.jpg',
    video:
      'https://sinoclick-test.oss-cn-hongkong.aliyuncs.com/shopify-pixel/demo/demo-2.mp4',
    title: 'Google Analytics',
  },
];
